import {memo} from 'react'
import {Skeleton, type SkeletonProps} from './Skeleton'

export const RectangularSkeleton = memo((props: SkeletonProps) => {
  return <Skeleton variant="rounded" {...props}/>
})
